import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/obras/listar/form_edit'
import Head from '../../../../components/head'


function EditarObrasScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Obra Pública" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarObrasScreen;